import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-select-background-color: var(--sds-select-background-color, var(--sds-color-background-default, var(--sds-color-neutral-background-default)));
		--_sds-select-text-color: var(--sds-select-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));

		--_sds-select-border-color: var(--sds-select-border-color, var(--sds-color-border-default, var(--sds-color-neutral-border-default)));
		--_sds-select-border-width: var(--sds-select-border-width, var(--sds-border-sm));
		--_sds-select-border-radius: var(--sds-select-border-radius, var(--sds-radius-sm));

		--_sds-select-font-family: var(--sds-select-font-family, var(--sds-typography-font-family-roboto));
		--_sds-select-font-size: var(--sds-select-font-size, var(--sds-components-font-size-content-md));
		--_sds-select-font-weight: var(--sds-select-font-weight, var(--sds-typography-font-weight-regular));
		--_sds-select-line-height: var(--sds-select-line-height, var(--sds-components-line-height-squeezed-md));
		--_sds-select-min-height: var(--sds-select-height, var(--sds-components-button-md));

		--_sds-select-gap: var(--sds-select-gap, var(--sds-spacing-3xs));
		--_sds-select-padding-block: var(--sds-select-padding-block, 0);
		--_sds-select-padding-inline: var(--sds-select-padding-inline, var(--sds-spacing-xs));
		--_sds-select-padding-icon-inline-end: var(--sds-spacing-lg);

		--_sds-select-disabled-opacity: var(--sds-select-disabled-opacity, var(--sds-color-states-disabled-opacity));
		--_sds-select-max-width: var(--sds-select-max-width, var(--sds-typography-max-line-width, 60ch));
		--_sds-select-width: var(--sds-select-width, fit-content);

		--_sds-select-label-text-color: var(--sds-select-label-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));
		--_sds-select-label-font-size: var(--sds-select-label-font-size, var(--sds-components-font-size-content-md));
		--_sds-select-label-font-weight: var(--sds-select-label-font-weight, var(--sds-typography-font-weight-medium));
		--_sds-select-label-line-height: var(--sds-select-label-line-height, var(--sds-components-line-height-squeezed-md));

		--_sds-select-helptext-text-color: var(--sds-select-helptext-text-color, var(--sds-color-text-subtle, var(--sds-color-neutral-text-subtle)));
		--_sds-select-helptext-font-size: var(--sds-select-helptext-font-size, var(--sds-components-font-size-content-md));
		--_sds-select-helptext-font-weight: var(--sds-select-helptext-font-weight, var(--sds-typography-font-weight-regular));
		--_sds-select-helptext-line-height: var(--sds-select-helptext-line-height, var(--sds-components-line-height-squeezed-md));

		--_sds-select-focus-color: var(--sds-select-focus-color, var(--sds-color-states-focus-outer));
		--_sds-select-focus-inner-color: var(--sds-select-focus-inner-color, var(--sds-color-states-focus-inner));
		--_sds-select-focus-spacing: var(--sds-select-focus-spacing, var(--sds-color-states-focus-spacing));

		--_sds-select-error-border-color: var(--sds-select-error-border-color, var(--sds-color-alert-danger-border-default, var(--sds-color-neutral-border-strong)));
		--_sds-select-error-text-color: var(--sds-select-error-text-color, var(--sds-color-alert-danger-text-default, var(--sds-color-neutral-text-default)));

		all: unset;
		display: block;
		text-align: start;
	}

	.sds-select {
		display: flex;
		flex-direction: column;
		gap: var(--_sds-select-gap);
		font-family: var(--_sds-select-font-family);
	}

	.sds-select__label {
		color: var(--_sds-select-label-text-color);
		font-size: var(--_sds-select-label-font-size);
		font-weight: var(--_sds-select-label-font-weight);
		line-height: var(--_sds-select-label-line-height);
	}

	.sds-select__label:has(sds-icon) {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: var(--_sds-select-gap);
	}

	.sds-select__help-text {
		color: var(--_sds-select-helptext-text-color);
		font-size: var(--_sds-select-helptext-font-size);
		font-weight: var(--_sds-select-helptext-font-weight);
		line-height: var(--_sds-select-helptext-line-height);
		margin: 0;
	}

	.sds-select__control {
		box-sizing: border-box;
		width: var(--_sds-select-width);
		max-width: var(--_sds-select-max-width);

		color: var(--_sds-select-text-color);
		background-color: var(--_sds-select-background-color);

		padding-block: var(--_sds-select-padding-block);
		padding-inline-start: var(--_sds-select-padding-inline);
		padding-inline-end: var(--_sds-select-padding-icon-inline-end);

		line-height: var(--_sds-select-line-height);
		font-size: var(--_sds-select-font-size);
		font-weight: var(--_sds-select-font-weight);
		font-family: var(--_sds-select-font-family);

		min-height: var(--_sds-select-min-height);
		border-radius: var(--_sds-select-border-radius);
		border: var(--_sds-select-border-width) solid var(--_sds-select-border-color);
		appearance: none;

		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 32 32'%3E%3Cpath d='M16 20.5 8 12.5 9.867 10.633 16 16.767 22.133 10.633 24 12.5Z'/%3E%3C/svg%3E");
		background-repeat: no-repeat;
		background-size: 2rem;
		background-position: top 50% right var(--sds-spacing-3xs);

		&:hover {
			--_sds-select-border-color: var(--sds-select-border-color, var(--sds-color-border-strong, var(--sds-color-neutral-border-strong)));
		}

		&:focus-visible {
			box-shadow: 0 0 0 var(--sds-color-states-focus-spacing) var(--_sds-select-focus-inner-color);
			outline: var(--_sds-select-focus-spacing) solid var(--_sds-select-focus-color);
			outline-offset: var(--_sds-select-focus-spacing);
		}

		&:open {
			background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 32 32'%3E%3Cpath d='m16 11.5 8 8-1.867 1.867L16 15.233l-6.133 6.134L8 19.5z'/%3E%3C/svg%3E");
		}
	}

	.sds-select--error .sds-select__control {
		border-color: var(--_sds-select-error-border-color);
	}

	.sds-select__error {
		color: var(--_sds-select-error-text-color);
		font-size: var(--_sds-select-helptext-font-size);
		line-height: var(--_sds-select-helptext-line-height);
		margin: 0;
		display: flex;
		align-items: center;
		gap: var(--sds-spacing-3xs);
	}

	:host([disabled]) .sds-select__control {
		opacity: var(--_sds-select-disabled-opacity);
		cursor: not-allowed;
	}

	.sds-select__icon {
		position: absolute;
		top: 50%;
		inset-inline-end: var(--_sds-select-padding-inline);
		transform: translateY(-50%);
		width: var(--sds-components-icon-md, 1rem);
		height: var(--sds-components-icon-md, 1rem);
		pointer-events: none;
		background-color: currentColor;
		mask: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.47 6.47a.75.75 0 0 1 1.06 0L8 8.94l2.47-2.47a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06z' fill='black'/%3E%3C/svg%3E")
			no-repeat center / contain;
	}

	:host([readonly]) {
		--_sds-select-background-color: var(--sds-select-background-color, var(--sds-color-surface-tinted, var(--sds-color-neutral-surface-tinted)));

		& .sds-select__control {
			pointer-events: none;
		}
	}

	:host([size='sm']) {
		--_sds-select-min-height: var(--sds-select-height, var(--sds-components-button-sm));
		--_sds-select-font-size: var(--sds-select-font-size, var(--sds-components-font-size-content-sm));
		--_sds-select-line-height: var(--sds-select-line-height, var(--sds-components-line-height-squeezed-sm));
		--_sds-select-label-font-size: var(--sds-select-label-font-size, var(--sds-components-font-size-content-sm));
		--_sds-select-label-line-height: var(--sds-select-label-line-height, var(--sds-components-line-height-squeezed-sm));
		--_sds-select-helptext-font-size: var(--sds-select-helptext-font-size, var(--sds-components-font-size-content-sm));
		--_sds-select-helptext-line-height: var(--sds-select-helptext-line-height, var(--sds-components-line-height-squeezed-sm));
	}

	:host([size='lg']) {
		--_sds-select-min-height: var(--sds-select-height, var(--sds-components-button-lg));
		--_sds-select-font-size: var(--sds-select-font-size, var(--sds-components-font-size-content-lg));
		--_sds-select-line-height: var(--sds-select-line-height, var(--sds-components-line-height-squeezed-lg));
		--_sds-select-label-font-size: var(--sds-select-label-font-size, var(--sds-components-font-size-content-lg));
		--_sds-select-label-line-height: var(--sds-select-label-line-height, var(--sds-components-line-height-squeezed-lg));
		--_sds-select-helptext-font-size: var(--sds-select-helptext-font-size, var(--sds-components-font-size-content-lg));
		--_sds-select-helptext-line-height: var(--sds-select-helptext-line-height, var(--sds-components-line-height-squeezed-lg));
	}
`;
